import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { BookingConfigService } from './booking-config.service';

@Injectable({
    providedIn: 'root'
})
export class RouteParamService {
    private orgSource = new BehaviorSubject<string>('');

    org$ = this.orgSource.asObservable();

    constructor(
        private bookingConfigService: BookingConfigService
    ) {}

    setOrg(org: string) {
        this.bookingConfigService.setOrganizationFromUrl();
        this.orgSource.next(org);
    }


}